import { ApiBase } from '@fan-services/models/api-base';

export class SecurityChecksApi extends ApiBase {
  model = 'security-checks';

  validateCaptcha(token: string) {
    return this.http.post<{ success: boolean }>(this.modelUri('validate-captcha-token'), { token });
  }
}
